import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { cn } from '@/lib/utils';

import characterLoaderShade from '/images/CharacterBrandWikiLoaderShade.svg';
import characterLoader from '/images/CharacterBrandWikiLoaderWithoutShade.svg';

interface CustomLoaderProps {
  title: string;
  loaderStyles?: string;
  isLoading: boolean;
  showImmediately?: boolean;
}

const CustomLoader: FC<CustomLoaderProps> = ({
  title,
  loaderStyles,
  isLoading,
  showImmediately,
}) => {
  const [isLoadingActive, setIsLoadingActive] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isLoading) {
      timeoutId = setTimeout(() => {
        setIsLoadingActive(true);
      }, 2000);
    } else {
      setIsLoadingActive(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoading]);

  return (
    ((showImmediately && isLoading) || isLoadingActive) && (
      <div className='absolute inset-0 z-100 bg-light flex justify-center items-center'>
        <div
          className={cn(
            {
              'p-16 md:rounded-xl flex flex-col gap-4 items-center': true,
              'bg-purple-light md:border md:border-purple-dark': !loaderStyles,
            },
            loaderStyles
          )}
        >
          <div>
            <img
              src={characterLoader}
              width={110}
              height={80}
              className='object-contain object-center'
              style={{ animation: 'bounce 3s infinite ' }}
            />
            <img
              src={characterLoaderShade}
              width={110}
              height={30}
              className='object-contain object-center'
              style={{ animation: 'bounce-scale 3s infinite ' }}
            />
          </div>
          <div className='text-center text-purpleDark text-[24px] lg:text-[36px] font-bold'>
            {title}
          </div>
        </div>
      </div>
    )
  );
};

export default CustomLoader;
